import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-edps-detailed-report",
  templateUrl: "./edps-detailed-report.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EdpsDetailedReportComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.EDPS_DETAILED_REPORT;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.PROJECT_NAME2];
}
